import { render, staticRenderFns } from "./HomeFeedSocial.vue?vue&type=template&id=7767cb28&scoped=true"
import script from "./HomeFeedSocial.vue?vue&type=script&lang=js"
export * from "./HomeFeedSocial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7767cb28",
  null
  
)

export default component.exports